import { FC } from "react";
import { DialogData, DialogHandle } from "../../types";
import { useApp } from "../../context/useApp";
import { Icon } from "../../parts/Icon";
import { DEFAULT_DIALOG_HANDLE } from "../../utils/symbols";
import { _ } from "../../utils/helpers";

interface SelectShiftFirstDialogProps {
    dialogData: DialogData
}

export const SelectShiftFirstDialog: FC<SelectShiftFirstDialogProps> = ({dialogData}) => {

    const {state: {
        dialogHandles
    }} = useApp()

    if (dialogData.dialog !== 'select-shift-first') return null

    const dialogHandle:DialogHandle = dialogHandles.get('table-map-dialog') ?? DEFAULT_DIALOG_HANDLE

    return (
        <>
        <section 
            className={`df fd-c jcfs aic r3 section p-r py-10 px-13`}
            aria-labelledby="dialog-title"
        >
            <Icon icon="info" style={{scale: '1.7'}}/>
            <h2 id="dialog-title" className="text s20-400 mb-8 mt-9 center">{_('2di_selec_m')}</h2>
            <button 
                className="button black px-10 py-7 r3 text white center s20-500 b-0"
                onClick={(e) => {
                    e.stopPropagation()
                    dialogHandle.closeDialog()
                }}
            >
                {_('0ge_under__')}
            </button>
        </section>
        <Icon icon="pointer" className="p-a"/>
        </>
    )
}